import React from 'react';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import {Helmet} from "react-helmet";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";

export default function CanadianMSBLicense() {

    return (
        <main className='main'>
            <Helmet>
                <title>Canadian MSB License | Register Money Services Business</title>
                <meta name="description" content="Register your Canadian MSB license with expert support. Fast, compliant setup for fintech, crypto, and payment businesses." />
                <meta name="keywords" content="
                    Canadian MSB license, MSB registration Canada, FINTRAC MSB, money services business Canada, crypto license Canada, fintech license Canada, remittance license Canada, FX license Canada, MSB compliance Canada, AML KYC Canada, virtual currency MSB Canada, payment processing license Canada, MSB requirements Canada, offshore MSB services, Canadian fintech setup, MSB registration process, money transfer license Canada, crypto compliance Canada, MSB consulting services
                              "
                />
            </Helmet>

            <IntroSection
                title="Canadian MSB License | Offshore Advisory"
                description=
                    {
                        `
                    Secure your Money Services Business (MSB) license in Canada and operate legally in one of the world’s most trusted financial jurisdictions. Offshore Advisory provides end-to-end support for fintech startups, crypto businesses, and financial service providers looking to register as an MSB in Canada.
                    <br/>
                    <br/>
                    With strong regulatory oversight, global credibility, and access to international markets, Canada is a leading destination for businesses offering money transfer, foreign exchange, virtual currency, and payment services. Our team ensures a smooth, compliant, and efficient MSB registration process.
                    `
                    }
                buttonText="Request a Ghana Gaming Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/Canadian MSB License 1.jpg')}
                imageAlt="Panama Gaming License"
            />


            <section className='section'>
                <div className="container">

                    <DetailsSection
                        title="Why Choose Canada for an MSB License?"
                        items={[
                            {
                                title: "Global Credibility",
                                text: "Canada is a highly respected financial jurisdiction."
                            },
                            {
                                title: "Regulated Framework",
                                text: "Operate under strict but transparent compliance laws."
                            },
                            {
                                title: "Fintech-Friendly Environment",
                                text: "Ideal for payment, remittance, and crypto businesses."
                            },
                            {
                                title: "International Reach ",
                                text: "Serve clients globally with a recognized MSB registration."
                            },
                            {
                                title: "Secure Banking Ecosystem",
                                text: "Access to reputable financial institutions."
                            },
                        ]}
                    />

                    <h1 className='page-title'>
                        Our Services & Step-by-Step MSB Registration Process
                    </h1>
                    <p className='page-paragraph'>
                        At Offshore Advisory, we provide complete support to help you register and operate as a Canadian MSB. From consultation to ongoing compliance, we simplify every step.
                    </p>

                    <WhySection
                        title='1. Consultation & Business Assessment'
                        subtitle='We begin by understanding your financial services model and regulatory needs. What we do:'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Assess your services (money transfer, crypto, FX, payments)"
                                    },
                                    {
                                        text: "Determine MSB eligibility and requirements"
                                    },
                                    {
                                        text: "Outline timelines, compliance obligations, and costs"
                                    },
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='2. Company Formation in Canada'
                        subtitle='To operate as an MSB, a Canadian entity is typically required. Our support includes:'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Incorporation of your Canadian company"
                                    },
                                    {
                                        text: "Structuring ownership and directorship"
                                    },
                                    {
                                        text: "Ensuring compliance with federal and provincial laws"
                                    },


                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='3. MSB Registration with FINTRAC'
                        subtitle='We handle your registration with Canada’s financial regulator. Our services cover:'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Preparing and submitting MSB registration"
                                    },
                                    {
                                        text: "Drafting AML (Anti-Money Laundering) and KYC policies"
                                    },
                                    {
                                        text: "Appointing a compliance officer"
                                    },
                                    {
                                        text: "Ensuring adherence to FINTRAC requirements"
                                    },
                                    {
                                        text: ""
                                    },
                                ]
                            }
                        ]}
                    />
                    <WhySection
                        title='4. Banking & Payment Integration'
                        subtitle='We help you become fully operational.'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Assistance with corporate bank account setup"
                                    },
                                    {
                                        text: "Integration with payment processors and gateways"
                                    },
                                    {
                                        text: "Guidance on crypto and fintech infrastructure"
                                    },
                                ]
                            }
                        ]}
                    />
                    <WhySection
                        title='5. Ongoing Compliance & Reporting'
                        subtitle='Maintaining compliance is critical for MSBs in Canada.'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Ongoing AML/KYC compliance support"
                                    },
                                    {
                                        text: "Transaction monitoring and reporting guidance"
                                    },
                                    {
                                        text: "Regulatory updates and audit assistance"
                                    },
                                    {
                                        text: "MSB renewal and record-keeping support"
                                    },
                                ]
                            }
                        ]}
                    />


                    <InfoBlocks
                        blocks={[
                            {
                                title: "Why This Approach Matters",
                                subtitle: "By combining regulatory expertise with a structured process, Offshore Advisory ensures your Canadian MSB registration is:",
                                items: [
                                    {
                                        title: "Fully Compliant",
                                        text: "Meets all FINTRAC requirements"
                                    },
                                    {
                                        title: "Efficient ",
                                        text: "Fast and streamlined registration"
                                    },
                                    {
                                        title: "Transparent ",
                                        text: "Clear timelines and costs"
                                    },
                                    {
                                        title: "Scalable ",
                                        text: "Designed for global fintech growth"
                                    },
                                ]
                            },

                        ]}
                    />


                    <InfoBlocks
                        blocks={[
                            {
                                title: "Types of Gaming Licenses in Ghana",
                                items: [
                                    {
                                        text: "Money Transfers & Remittance Services"
                                    },
                                    {
                                        text: "Foreign Exchange (FX) Services"
                                    },
                                    {
                                        text: "Virtual Currency (Crypto) Businesses"
                                    },
                                    {
                                        text: "Payment Processing & Fintech Solutions"
                                    },

                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Who Can Benefit?'
                        services={
                            [
                                {
                                    title: "Fintech Startups",
                                    text: "Launch regulated financial services"
                                },
                                {
                                    title: "Crypto Businesses",
                                    text: "Operate legally with virtual currency services",
                                },
                                {
                                    title: "Remittance Companies",
                                    text: "Send and receive international payments",
                                },
                                {
                                    title: "Payment Service Providers",
                                    text: "Expand into global markets",
                                },
                            ]
                        }
                        end="A Canadian MSB license positions your business as a credible and compliant player in the global financial ecosystem."
                    />


                    <Testimonials
                        title="Our Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <FAQList data={faqData} title='FAQs – Canadian MSB License'/>

                    <CTA
                        title="Contact Offshore Advisory Today!"
                        description="Ready to register your Canadian MSB and launch your financial services business? Offshore Advisory ensures a fast, compliant, and hassle-free process."
                        buttonText="Get Started Today →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is an MSB license in Canada?",
        answer: "It is a registration with FINTRAC that allows businesses to legally offer money services such as transfers, FX, and crypto."
    },
    {
        question: "Do I need to be a Canadian resident?",
        answer: "No, non-residents can register, but a Canadian entity is typically required."
    },
    {
        question: "How long does registration take?",
        answer: "Usually 2–4 weeks, depending on documentation readiness."
    },
    {
        question: "Is a bank account required?",
        answer: "Yes, a corporate bank account is essential for operations."
    },
    {
        question: "Are there ongoing compliance requirements?",
        answer: "Yes, MSBs must follow strict AML/KYC and reporting obligations."
    },
];

const testimonialsData = [
    {
        quote: "Offshore Advisory made our MSB registration in Canada seamless. Their compliance support was exceptional.",
        author: "Alex P.",
        role: "Fintech Founder"
    },
    {
        quote: "We were able to launch our crypto services quickly thanks to their structured approach and expertise.",
        author: "Maria L.",
        role: "Crypto Entrepreneur"
    },

];

